import React, { useState, useEffect, useMemo } from 'react';
import { Toolbar, Container, Box } from '@mui/material';
import { ImgBox } from 'views/common/components';
import StyledAppBar from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar/NavBar.styles';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import {
  NavMenu,
  NavMenuItem,
  LanguageAndRegion,
} from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar';
import useDropdownMenuItems from 'views/rebranded-module/common/hooks/useDropdownMenuItems';
import useNavigationItems from 'views/rebranded-module/common/hooks/useNavigationItems';
import { useTranslation } from 'next-i18next';
import { UtilityNav } from 'views/rebranded-module/common/components/Logical/LayoutV2';
import { useSelector } from 'react-redux';
import {
  GeoWidgetSection,
  GeoWidgetSectionSkeleton,
} from 'views/rebranded-module/GeoViewV2/components';
import { useGeoCMSData } from 'views/rebranded-module/GeoViewV2/hooks/useGeoCMSData';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';

const NavBar = (props) => {
  const { t } = useTranslation();
  const {
    isAdVisible,
    simple,
    transparent,
    staticPosition,
    reservationPath,
    adHeight,
    showGeoFilters,
  } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const navigationItems = useNavigationItems(simple);
  const dropdownMenuItems = useDropdownMenuItems(simple, reservationPath);
  const { appState } = useSelector((state) => state.globalData);
  const error = useSelector((state) => state.ui.error);
  const isTransparent = transparent || error.statusCode;
  const geoCMSContent = useGeoCMSData();
  const geofiltersData = useSelector((state) => state.geofilters.filtersData);
  const showCompanyName = appState.settings?.show_current_company
    && appState.current_company
    && appState.current_company.name;
  const showRenalMangagment = appState.settings?.show_rental_management_link;
  const showUtilityNav = showCompanyName || showRenalMangagment;

  const memoizedAdHeight = useMemo(
    () => (isAdVisible ? adHeight : 0),
    [isAdVisible, adHeight],
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const renderGeoWidget = () => {
    if (!geofiltersData) {
      return <GeoWidgetSectionSkeleton />;
    }

    return (
      <ContentContext.Provider value={geoCMSContent.data}>
        <GeoWidgetSection
          rentalData={geofiltersData.rentalData}
          widgetRef={geofiltersData.widgetRef}
          handleFieldChange={geofiltersData.handleFieldChange}
          openFilterDialog={geofiltersData.openFilterDialog}
          handleClearVehicleFilters={geofiltersData.handleClearVehicleFilters}
          handleFilterDialogClose={geofiltersData.handleFilterDialogClose}
        />
      </ContentContext.Provider>
    );
  };
  const renderLogoImage = (imgSrc, imgFit) => (
    <ImgBox
      image={{
        src: imgSrc || '/imgs/Rebranding/logos/horizontal-light.svg',
        alt: t('common_layout_v2:er_logo'),
      }}
      imgHeight="100%"
      imgWidth="100%"
      imgObjectFit={imgFit || 'contain'}
    />
  );
  return (
    <StyledAppBar
      addHeight={memoizedAdHeight}
      className={`${isTransparent ? 'NBTransparent' : ''}  ${
        isAdVisible ? 'NBAdVisible' : ''
      } 
      ${isScrolled ? 'NBScrolled' : ''}
      ${staticPosition && 'NBStaticPosition'}
      NBAppBar`}>
      {showUtilityNav && <UtilityNav />}
      <Box
        className={`${
          showGeoFilters ? 'NVContainerWrapperBackgroundDefault' : ''
        }`}>
        <Container maxWidth="xxl" className="NVContainer">
          <Toolbar className="NMToolBar">
            <Box className="NavBarLogoContainer">
              <NavigatorLink className="NBLogoLink" href={PATHS.home()}>
                <Box className="NavBarLogo">{renderLogoImage()}</Box>
              </NavigatorLink>
            </Box>
            {!simple && !reservationPath && (
              <Box className="NBNavigaationLinksContainer showLargeDESKTOP">
                {navigationItems.map((item) => (
                  <NavMenuItem key={item.label} item={item} preventAnimation />
                ))}
              </Box>
            )}
            <LanguageAndRegion />
            <NavMenu dropdownMenuItems={dropdownMenuItems} />
          </Toolbar>
        </Container>
      </Box>
      {showGeoFilters && (
        <Box className="NavBarFiltersGeo">{renderGeoWidget()}</Box>
      )}
    </StyledAppBar>
  );
};

export { NavBar };
